<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.phone"
        placeholder="下级手机号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.level"
        placeholder="下级层级"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in SHOP_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="create"
        startPlaceholder="加入开始时间"
        endPlaceholder="加入结束时间"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <div style="margin: 10px 0 20px">
      <dashboard-card :balanceData="balanceData" />
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        label="下级手机号"
        align="center"
        prop="phone"
      ></el-table-column>
      <el-table-column
        label="直属上级手机号"
        align="center"
        prop="superiorPhone"
      ></el-table-column>
      <el-table-column label="所属层级" align="center" prop="level"
        ><template slot-scope="scope"> {{ scope.row.level }}级 </template>
      </el-table-column>

      <el-table-column
        label="下属人数"
        align="center"
        prop="subordinateCount"
      ></el-table-column>

      <el-table-column
        label="总销售额"
        align="center"
        prop="totalOrderAmount"
      ></el-table-column>
      <el-table-column
        label="总分润额"
        align="center"
        prop="totalDividendAmount"
      ></el-table-column>
      <el-table-column
        label="加入日期"
        align="center"
        prop="joinDate"
      ></el-table-column>
      <el-table-column
        label="登录后台"
        align="center"
        prop="isAgentLogin"
        width="100"
        ><template slot-scope="scope">
          {{ scope.row.isAgentLogin ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="100"
        class-name="small-padding fixed-width"
        v-if="
          (isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT || !disabled) &&
            isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        "
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="onDialogVisible(true, scope.row)"
            >设置</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout=" prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      title="设置下级登录状态"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :width="isMobile ? '90%' : '400px'"
      :modal-append-to-body="true"
      :append-to-body="true"
      custom-class="subordinate-dialog"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="50px"
        :style="{
          width: '100%',
          maxWidth: isMobile ? '95vw' : '380px',
          margin: '0 auto',
        }"
      >
        <el-form-item label="" prop="isAgentLogin">
          <el-radio-group
            v-model="form.isAgentLogin"
            :size="isMobile ? 'medium' : 'small'"
            :style="{ marginTop: isMobile ? '10px' : '0' }"
          >
            <el-radio
              label="1"
              :style="{ marginRight: isMobile ? '20px' : '10px' }"
              >允许登录后台</el-radio
            >
            <el-radio label="0">不可登录后台</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="checkAddOrEditDialogVisible(false, {}, '')"
          :size="isMobile ? 'medium' : 'small'"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="saveAddOrEditData"
          :loading="btnLoading"
          :size="isMobile ? 'medium' : 'small'"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLogionUserInfo } from "@/utils/auth";
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";
import DataPicker from "@/views/components/dataPicker.vue";
import { getLowerLevelDtoList, setAgentLogin } from "@/api/leve.js";
import { getBalanceStatis, getUsersStatis } from "@/api/dashboard";
import dashboardCard from "@/components/dashboardCard/index.vue";

export default {
  name: "withdrawalRecords",
  props: {
    agentDetail: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      isMobile: false,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        pageSize: 10,
        phone: "",
        level: 0,
        startTime: "",
        endTime: "",
      },
      btnLoading: false,
      rules: {
        isAgentLogin: [
          {
            required: true,
            message: "请选择是否允许登录后台",
            trigger: "blur",
          },
        ],
      },
      SHOP_STATUS: [
        {
          key: 0,
          value: "全部",
        },
        {
          key: 1,
          value: "直属",
        },
        {
          key: "2",
          value: "2级",
        },
        {
          key: "3",
          value: "3级",
        },
        {
          key: "4",
          value: "4级",
        },
        {
          key: "5",
          value: "5级",
        },
        {
          key: "6",
          value: "6级",
        },
        {
          key: "7",
          value: "7级",
        },
        {
          key: "8",
          value: "8级",
        },
      ],
      balanceData: [],
      isAgentLogin: null,
      dialogVisible: false,
      form: {
        isAgentLogin: "",
      },
      agentUserId: "",
    };
  },

  mounted() {
    // 初始化时检测设备类型
    this.checkIsMobile();
    // 监听窗口大小变化
    window.addEventListener("resize", this.checkIsMobile);
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听
    window.removeEventListener("resize", this.checkIsMobile);
  },
  created() {
    this.isAgentLogin = getLogionUserInfo().isAgentLogin;
    this.agentUserId =
      (this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT && this.disabled) ||
      this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        ? this.agentDetail?.agentUserId
        : getLogionUserInfo().agentUserId;

    console.log(
      "---222",
      this.agentUserId,
      this.agentDetail,
      getLogionUserInfo()
    );
    this.getList();
    this.onBalanceStatis();
  },
  methods: {
    // 检测是否为移动设备
    checkIsMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    onBalanceStatis() {
      const params = { agentUserId: this.agentUserId };
      console.log("2---2", this.agentUserId);
      Promise.all([getBalanceStatis(params), getUsersStatis(params)]).then(
        ([res1, res2]) => {
          const data1 = res1.data;
          const data2 = res2.data;
          this.balanceData = [
            {
              name: "下级人数",
              //   iconUrl:"@/assets/dashboard/icon_xjyj.png",
              iconUrl: require("@/assets/dashboard/icon_xjyj.png"),
              todayAmount: data2.totalTodayNumber,
              cumulativeAmount: data2.totalNumber,
              color: "#F1F7FF",
              leftTitle: "今日新增",
              rightTitle: "总人数",
            },
            {
              name: "销售额",
              iconUrl: require("@/assets/dashboard/icon_cjcs.png"),
              todayAmount: data1.todaySuccessAmount,
              cumulativeAmount: data1.totalSuccessAmount,
              color: "#F1F7FF",
              leftTitle: "今日",
              rightTitle: "累计",
            },
            {
              name: "分润额",
              iconUrl: require("@/assets/dashboard/icon_xjhb.png"),
              todayAmount: data1.todayProfit,
              cumulativeAmount: data1.totalProfit,
              color: "#FFF5EA",
              leftTitle: "今日",
              rightTitle: "累计",
            },
          ];
          if (this.isAgentLogin == 2) {
            this.balanceData = this.balanceData.filter(
              (item) => item.name !== "分润额"
            );
          }
        }
      );
    },
    getList() {
      this.listLoading = false;
      this.listQuery.agentUserId = this.agentUserId;
      console.log("---333", this.listQuery);
      getLowerLevelDtoList(this.listQuery).then((res) => {
        this.list = res.data.entitys;
        this.total = res.data.totalCount;
        this.listLoading = false;
      });
    },
    saveAddOrEditData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          setAgentLogin(this.form).then((res) => {
            if (res.data) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.dialogVisible = false;
              this.getList();
            }
          });
        }
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      this.listQuery.startTime = value[0];
      this.listQuery.endTime = value[1];
    },

    onDialogVisible(status, row) {
      // 先设置表单数据，再显示对话框
      if (row) {
        // 确保类型转换正确
        const agentLoginValue = String(row.isAgentLogin);
        this.form = {
          userId: row.userId,
          isAgentLogin:
            agentLoginValue === "1" || agentLoginValue === "2" ? "1" : "0",
        };
      }
      // 使用$nextTick确保DOM更新后再显示对话框
      this.$nextTick(() => {
        this.dialogVisible = status;
      });
    },
    checkAddOrEditDialogVisible() {
      this.dialogVisible = false;
    },
  },
  computed: {
    AGENT_LOGIN_ROLE_VAL() {
      return AGENT_LOGIN_ROLE_VAL;
    },
  },
  components: {
    DataPicker,
    dashboardCard,
  },
};
</script>

<style scoped lang="scss">
.pagination-container {
  float: none;
  text-align: end;
  margin: 20px 0 0;
}
</style>
